import { render, staticRenderFns } from "./CollapseCards.vue?vue&type=template&id=7caf1f2f"
import script from "./CollapseCards.vue?vue&type=script&lang=js"
export * from "./CollapseCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports